"use strict";

/**
* Реквизит типа "Список обьектов".
*
* @class WebAccess.components.wrappers.form.requisites.ObjectList
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {obbject} data Данные для инициализации реквизита
* @since 5.2.0.2014
*/
(function (global) {



  var ObjectList = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "ObjectList",

    /**
    * Получить контролы реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_bindEvents
    * @private
    * @return {array} список jquery объектов
    * @since 5.2.0.2014
    */
    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];
        var jControl = $('#' + id + '_list');
        res.push(jControl);
      }
      return res;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Вызвать событие изменения
    * @private
    */
    _fireChange: function (reqFullName, value, displayValue, opt_ev) {
      var me = this;
      me.touch();
      me.fire("change", this, opt_ev, { name: reqFullName, value: me.getValue(), displayValue: null });
      if (this._parent && this._parent.form) this._parent.form.fire("change", this, opt_ev, { name: reqFullName, value: me.getValue(), displayValue: displayValue });
    },


    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.ObjectList
    */
    _showSpinner: function () {
      var me = this;
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.ObjectList
    */
    _hideSpinner: function () {
      var me = this;
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#getDisplayValue
    * @ignore
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      return;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить выбранные ссылки.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#getDisplayValue
    * @ignore
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    * @since 5.2.0.2014
    */
    getSelectedValue: function( ) {
      return this._getControlValue(this.controlsIds[0], 'GetSelectedLinks')
    },

    /**
    * Установить значение отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#setValue
    * @param value {WebAccess.Link|WebAccess.Link[]} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.ObjectList} Текущий объект реквизита – ObjectList.
    * @since 5.2.0.2014
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;
      if (_.isUndefined(value)) return;
      opt_needTriggerResult = (opt_needTriggerResult !== false);

      if (!_.isArray(value)) value = [value];
      _.each(me.controlsIds, function (name) {
        var list = ListRequisite(name);
        var links = _(value).map(function (link) {
          return link.toLinkModel();
        });
        list.Values = links;
        list.UpdateList();
      });

      this.touch();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить контрол подписи.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_getLabelForControl
    * @private
    * @since 5.0.0.7100
    * @return {object}
    */
    _getLabelForControl: function (jControl) {
      var jC = jControl.parents('.Card_Element:first').prev('.CardForm_Label');
      if (jC.length) return jC;
      return jControl.parents('tr').eq(1).find('td.wizard-table__cell_type_label');
    },

    /**
    * Получить значение в поле по его имени.
    *
    * @private
    * @function WebAccess.components.wrappers.form.requisites.ObjectList#_getControlValue
    * @since 5.2.0.2014
    * @return {Array<WA.Link>}
    */
    _getControlValue: function (controlName, method) {
      method =  method || 'GetLinks';

      var value;
      var result = ListRequisite(controlName)[method]();

      if (result.links) {
        return _(result.links).map(function (link) {
          var newLink = new WA.Link({});
          return newLink.fromLinkModel(link);
        });
      } else {
        return null;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак недоступности реквизита справочника для изменения.
     *
     * @function WebAccess.components.wrappers.form.requisites.ObjectList#isDisabled
     * @return {Boolean} True – реквизит справочника доступен только для чтения, иначе False.
    * @since 5.2.0.2014
     */
    isDisabled: function () {
      return ListRequisite(this.controlsIds[0]).ReadOnly;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отключение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_disableControl
    * @private
    * @return {WebAccess.components.wrappers.form.requisites.ObjectList}
    * @since 5.2.0.2014
    */
    _disableControl: function (jControl) {
      _.each(this.controlsIds, function (name) {
        ListRequisite(name).Disable();
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_enableControl
    * @private
    * @return {WebAccess.components.wrappers.form.requisites.ObjectList}
    * @since 5.2.0.2014
    */
    _enableControl: function (jControl) {
      _.each(this.controlsIds, function (name) {
        ListRequisite(name).Enable();
      });
      return this;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация событий.
    *
    * @private
    * @method WebAccess.components.wrappers.form.requisites.ObjectList#_bindEvents
    * @since 5.2.0.2014
    * @return  WebAccess.components.wrappers.form.requisites.ObjectList
    */
    _bindEvents: function () {
      var me = this;
      if (me.controls.length === 0) return this;
      $.each(me.controls, function () {
        me._bindControlEvents($(this).parents('.ListRequisite'));
      });
      return me;
    }

  });

  global.WA.CMP.wrappers.form.requisites.ObjectList = ObjectList;
})(window);
